import useApiMutation from './useApiMutation';

function useRegisterMutation(options) {
  return useApiMutation('post', '/v1/register', options);
}

export default useRegisterMutation;
